import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import Community from "../Community";

class Home extends Component {
  componentDidMount() {
    const { navCommunity, push } = this.props;
    if (navCommunity && navCommunity.id) {
      push(`/community/${navCommunity.url}/${navCommunity.id}`);
    }
  }

  render() {
    return <Community />;
  }
}

// Connected Component
const mapStateToProps = state => ({
  navCommunity: state.auth.navCommunity
});

const mapDispatchToProps = dispatch => ({
  push: url => dispatch(push(url))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/components/Community/Home.js